import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5888 0C6.97929 0 0 6.97929 0 15.5888C0 23.3189 5.62641 29.7347 13.0074 30.9647V20.0874H9.27419V15.7683H13.0074V12.5814C13.0074 8.87795 15.2711 6.86254 18.5673 6.86254C19.6793 6.86254 20.7912 6.92221 21.9032 7.03142V10.9035H19.6098C17.8127 10.9035 17.475 11.7573 17.475 13.0083V15.7683H21.7542L21.1983 20.0874H17.475V31.0642C25.1949 30.1331 31.1774 23.5597 31.1774 15.5888C31.1777 6.97929 24.1981 0 15.5888 0Z",
		fill: "#EDFEF6"
	})
});
export { SvgFacebook as ReactComponent };
